<template>
  <div
      class="border border-grey shadow-custom-drop-shadow-number pader rounded-[32px] py-2 px-4 lg:px-24 lg:py-0 md:gap-10 my-16"
  >
    <div class="flex justify-between items-center mt-4 space-x-4">
      <div class="p-0 sm:p-2 text-blue font-semibold">Pick any 06 numbers</div>
      <div class="flex sm:space-x-6 space-x-4 items-center">
        <button @click="quickPickAll" class="flex items-center space-x-1">
          <div class="flex items-center space-x-1">
            <IconCircle/>
            <p
                class="sm:text-base text-sm sm:text-left text-center text-blue font-medium"
            >
              Quick Pick All
            </p>
          </div>
        </button>
        <button @click="clearAll" class="flex items-center space-x-1">
          <p
              class="sm:text-base text-sm sm:text-left text-center font-medium text-blue"
          >
            Clear All
          </p>
          <IconBin/>
        </button>
      </div>
    </div>
    <hr class="border-t-2 border-gray-300 mt-3"/>

    <div class="p-4">
      <div class="flex justify-center space-x-3 my-8">
        <div
            v-for="(num, index) in selectedNums"
            :key="index"
            class="width-4 flex flex-col items-center"
        >
          <span class="text-blue font-semibold">{{
              num !== null ? num.toString().padStart(2, "0") : ""
            }}</span>
          <span class="w-8 h-0.5 bg-customGrey mt-1"/>
        </div>
      </div>

      <div
          class="grid grid-cols-6 sm:grid-cols-8 md:grid-cols-9 lg:grid-cols-12 lg:gap-5 sm:gap-6 gap-2 justify-center p-0 sm:p-4 items-center"
      >
        <button
            v-for="(num, index) in 35"
            :key="num"
            :class="buttonClass(index)"
            @click="toggleColor(index)"
            class="flex items-center justify-center sm:w-12 sm:h-12 w-10 h-10 rounded-full border border-gray"
        >
          {{ num.toString().padStart(2, "0") }}
        </button>
      </div>
      <button
          :disabled="!isSelectionComplete"
          @click="choosePowerBall"
          :class="{
          'bg-customPink cursor-pointer': isSelectionComplete,
          'bg-darkGrey  cursor-not-allowed': !isSelectionComplete,
        }"
          class="px-8 py-3 text-white rounded-[30px] mt-8 mb-4"
      >
        Choose Power Ball Number
      </button>
    </div>
  </div>
</template>

<script>
import IconCircle from "@/components/IconCircle.vue";
import IconBin from "@/components/IconBin.vue";

export default {
  data() {
    return {
      clickedButtons: Array(35).fill(false),
      selectedNums: Array(7).fill(null),
      maxNums: 7,
    };
  },
  computed: {
    isSelectionComplete() {
      return (
          this.selectedNums.filter((num) => num !== null).length === this.maxNums
      );
    },
  },
  methods: {
    buttonClass(index) {
      return this.clickedButtons[index]
          ? "bg-customPink text-white"
          : "bg-paleGrey text-black";
    },
    toggleColor(index) {
      if (this.clickedButtons[index]) {
        const numToRemove = index + 1;
        const numIndex = this.selectedNums.findIndex(
            (num) => num === numToRemove
        );
        if (numIndex !== -1) {
          this.selectedNums.splice(numIndex, 1, null);
        }
        this.clickedButtons[index] = false;
      } else if (
          this.selectedNums.filter((num) => num !== null).length < this.maxNums
      ) {
        const emptyIndex = this.selectedNums.findIndex((num) => num === null);
        if (emptyIndex !== -1) {
          this.selectedNums.splice(emptyIndex, 1, index + 1);
        }
        this.clickedButtons[index] = true;
      }
      this.selectedNums = this.selectedNums.filter((num) => num !== null);
      while (this.selectedNums.length < this.maxNums) {
        this.selectedNums.push(null);
      }
    },
    clearAll() {
      this.clickedButtons.fill(false);
      this.selectedNums.fill(null);
    },
    choosePowerBall() {
      this.$emit("clicked", this.selectedNums);
    },
    quickPickAll() {
      const randomNumbers = [];
      while (randomNumbers.length < this.maxNums) {
        const randomNumber = Math.floor(Math.random() * 35) + 1;
        if (!randomNumbers.includes(randomNumber)) {
          randomNumbers.push(randomNumber);
        }
      }

      this.clickedButtons.fill(false);
      this.selectedNums.fill(null);

      randomNumbers.forEach((num) => {
        const emptyIndex = this.selectedNums.findIndex((item) => item === null);
        if (emptyIndex !== -1) {
          this.selectedNums.splice(emptyIndex, 1, num);
          this.clickedButtons[num - 1] = true;
        }
      });
    },
  },
  name: "PickNumbers",
  components: {
    IconCircle,
    IconBin,
  },
};
</script>

<style scoped>
/* Scoped styles specific to your component */
</style>
